import script from "./CreateUpdateLearningOutcome.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateLearningOutcome.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateLearningOutcome.vue?vue&type=style&index=0&id=7140ebc1&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7140ebc1"]])

export default __exports__